import TextButton from 'components/Luxkit/Button/TextButton'
import DropdownList from 'components/Luxkit/Dropdown/List/DropdownList'
import useToggle from 'hooks/useToggle'
import React, { forwardRef, useContext, useRef } from 'react'
import BusinessTravellerAccountMenuContent from './BusinessTravellerAccountMenuContent'
import { useScreenSizeOnly } from 'hooks/useScreenSize'
import BusinessAccountModeIcon from './BusinessAccountModeIcon'
import Group from 'components/utils/Group'
import Caption from 'components/Luxkit/Typography/Caption'
import FormatCurrency from 'components/Common/FormatCurrency'
import { connect } from 'react-redux'
import useBusinessTravellerPendingApprovalsFetcher from 'businessTraveller/hooks/useBusinessTravellerPendingApprovalsFetcher'
import GeoContext from 'contexts/geoContext'
import SolidCircleIcon from 'components/Luxkit/Icons/solid/SolidCircleIcon'
import { useAppSelector } from 'hooks/reduxHooks'

interface Props {
  className?: string
  balance?: number
}

const MENU_TITLE = 'Your account'

const BusinessTravellerAccountButtonMenu = forwardRef<HTMLDivElement, Props>((props, ref) => {
  const { off, value, toggle } = useToggle()
  const accountButtonRef = useRef<HTMLButtonElement>(null)
  const isMobileScreen = useScreenSizeOnly('mobile')
  const { balance } = props
  const { currentRegionCode } = useContext(GeoContext)
  const { approvalRequests: pendingApprovals } = useBusinessTravellerPendingApprovalsFetcher({ currentRegionCode })
  const employeeRoles = useAppSelector(state => state.businessTraveller.currentBusinessAccount?.employee?.roles)

  const canSeeMyApprovals = employeeRoles?.includes('BUSINESS_APPROVER') || employeeRoles?.includes('BUSINESS_ADMIN') || employeeRoles?.includes('BUSINESS_MANAGER')

  return <Group direction="horizontal" ref={ref}>
    <TextButton
      kind="primary"
      variant="ghost"
      to="/business-traveller/my-approvals"
    >
      My Approvals {!!pendingApprovals?.length && canSeeMyApprovals && <SolidCircleIcon style={{ width: 6, height: 6, marginLeft: 2, marginBottom: 8 }} colour="critical" />}
    </TextButton>
    <TextButton
      kind="primary"
      variant="ghost"
      to="/account/my-escapes"
    >
      My Bookings
    </TextButton>
    <TextButton
      ref={accountButtonRef}
      kind="tertiary"
      variant="dark"
      startIcon={<BusinessAccountModeIcon />}
      onClick={toggle}
    >
      <div>
        Account
        {!!balance && <Caption variant="small">
          <FormatCurrency value={balance} format="dynamicDollar" />
        </Caption>}
      </div>
    </TextButton>
    <DropdownList
      size="M"
      open={value && !isMobileScreen}
      title={MENU_TITLE}
      onClose={off}
      triggerRef={accountButtonRef}
      anchorRef={accountButtonRef}
    >
      <BusinessTravellerAccountMenuContent onListItemClick={off} />
    </DropdownList>
  </Group>
})

function mapStateToProps(state: App.State) {
  return {
    balance: state.auth.account.balance,
  }
}

export default connect(mapStateToProps)(BusinessTravellerAccountButtonMenu)
